import WebFont from 'webfontloader';

export interface IFontItem
{
    set: string
    family: string
    category: string
}

export class FontLoader
{
    static instance = new FontLoader();

    processing = false;
    queue: { family: string, resolve: ((result: boolean) => void) }[] = [];
    loaded = new Set<string>();

    async loadItem(item: IFontItem)
    {
        if (item.set === 'webSafe') { return true; }
        return await this.load(item.family);
    }

    async load(family: string)
    {
        if (!family) { return false; }
        if (this.loaded.has(family)) { return true; }
        return await new Promise<boolean>(resolve => { this.queue.push({ family, resolve }); this._process(); });
    }

    async _process()
    {
        if (this.processing) { return; }
        try
        {
            this.processing = true;
            while (this.queue.length)
            {
                const { family, resolve } = this.queue.shift()!;
                try
                {
                    const isLoaded = await this._load(family);
                    if (isLoaded) { this.loaded.add(family); }
                    resolve(isLoaded);
                }
                catch
                {
                    resolve(false);
                }
            }
        }
        finally
        {
            this.processing = false;
        }
    }

    _load(family: string): Promise<boolean>
    {
        return new Promise<boolean>((resolve, inactive) => WebFont.load({ google: { families: [family] }, active: () => resolve(true), inactive }));
    }
}